import { gql } from "shared/lib/graphql"

export type CreditsBalanceStatus = "ok" | "moderate" | "low" | "very_low" | "empty"

export interface CreditsBalance {
  remaining: number
  reset_date: string
  spent: number
  status: CreditsBalanceStatus
  total: number
}

export const CreditsBalanceFields = gql`
  remaining
  reset_date
  spent
  status
  total
`
